import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {TabelleControl, UiInputControl} from '../../models/uiArtefakt';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorService} from '../../../lib-core/services/error.service';
import {TabellenService} from '../../services/tabellen.service';


@Component({
    selector: 'lv-tabelle',
    templateUrl: './tabelle.component.html',
    styleUrls: ['./tabelle.component.scss'],
    providers: [TabellenService],
    standalone: false
})
export class TabelleComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  dataSource: MatTableDataSource<UiInputControl>;

  private _uiArtefakt: TabelleControl;

  constructor(private _errorService: ErrorService, public tabellenService: TabellenService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): TabelleControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: TabelleControl) {
    if (!!this._uiArtefakt) {
      this._uiArtefakt = uiArtefakt;
      this.tabellenService.updateTableContent(this._uiArtefakt);
      this.dataSource = new MatTableDataSource<UiInputControl>(this.tabellenService.rows);
    } else {
      this._uiArtefakt = uiArtefakt;
    }
  }

  public ngOnInit(): void {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public trackByFn(index: number, item: UiInputControl) {
    return item.Identifikator;
  }


  private initTable() {
    this.tabellenService.createTable(this._uiArtefakt);
    this.dataSource = new MatTableDataSource<UiInputControl>(this.tabellenService.rows);

    if (this._uiArtefakt.Tabellengestaltung) {
      this.tabellenService.setTabellengestaltung(this._uiArtefakt.Tabellengestaltung, this._uiArtefakt.Identifikator);
    } else {
      this.tabellenService.setDefaultWidths();
    }
  }
}
